<div class="w-full h-full flex flex-col items-center justify-center relative p-4">
  <!-- Image -->
  <img
    [src]="images[currentIndex]"
    alt="Gallery Image"
    class="max-h-[70vh] w-auto object-contain rounded-md shadow-lg"
  />

  <!-- Navigation -->
  <div class="flex items-center justify-center gap-6 mt-6">
    <button (click)="prev()" class="text-white text-2xl px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded">⟵</button>
    <span class="text-white text-sm">{{ currentIndex + 1 }} / {{ images.length }}</span>
    <button (click)="next()" class="text-white text-2xl px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded">⟶</button>
  </div>

  <!-- Close -->
  <button (click)="close()"
          class="absolute top-4 right-4 bg-red-500 text-white text-xl px-3 py-2 rounded-full hover:bg-red-600 transition">
    ✕
  </button>
</div>
